import { weekDaysLong, weekDaysShort } from '@utils';
import React, { useEffect, useRef, useState } from 'react';
import '../../../../styles/components/calendar/weekCalendar.scss';
import { CurrentTimeLine } from '../../../currentTimeLine';
import { Cols } from '../../components';
import { Header } from './Header';

export const WeekCalendar = () => {
  const [weekDays, setWeekDays] = useState(weekDaysLong);

  const observer = useRef(
    new ResizeObserver((entries) => setWeekDays(entries[0].contentRect.width < 1100 ? weekDaysShort : weekDaysLong))
  );

  useEffect(() => {
    observer.current.observe(document.body);
  },
    [observer]);

  return (
    <div className="calendar week-calendar">
      <CurrentTimeLine />
      <Header weekDays={weekDays} />
      <Cols />
    </div>
  );
};
